module.exports = __webpack_public_path__ + "img/feature8.32f4089.png";